import { combineReducers } from 'redux';
import { sinatra } from '@rsos/sinatra';
import app from './appReducer';
import issues from './issuesReducer';
import psaps from './psapsReducer';

const rootReducer = combineReducers({
  sinatra,
  app,
  psaps,
  issues,
});

export default rootReducer;
